import httpClient from "@/config/axios";
import type * as type from "@vTypes";

/** POST /contact/write - httpClient 사용 (FormData는 axios가 multipart로 전송) */
export async function question(payload: type.QuestionPayload) {
  const formData = new FormData();
  formData.append("username", payload.username);
  formData.append("PortableTel", payload.PortableTel);
  formData.append("Email", payload.Email);
  formData.append("title", payload.title);
  formData.append("contents", payload.contents);

  return httpClient.post("/contact/write", formData);
}

/** DELETE /contact/{no} - 나의 문의내역 삭제 (본인 작성 문의만 삭제 가능) */
export async function deleteContact(no: number) {
  return httpClient.delete(`/contact/${no}`);
}
